import { getAccentColor, getBackgroundColor, getOutlineColor, } from '../../colors/colors.alias';
import { getBorderRadius, getBorderWidth, getBorderStyle, getOutlineOffset, getOutlineStyle, getOutlineWidth, } from '../../borders/borders.alias';
import { getHeight, getWidth } from '../../sizes/sizes.alias';
import { constants as Label } from '../Label';
import { VARIANT_DEFAULT, VARIANT_MEDIUM, VARIANT_SMALL, ELEMENT_RADIO, ELEMENT_LABEL, DATA_STATE_CHECKED, INTERACTION_STATE_HOVER, INTERACTION_STATE_FOCUS_VISIBLE, } from '../../constants';
export const constants = Object.freeze({
    NAME: 'RadioButton',
    variants: {
        VARIANT_DEFAULT,
        VARIANT_MEDIUM,
        VARIANT_SMALL,
    },
    elements: {
        ELEMENT_RADIO,
        ELEMENT_LABEL,
    },
    dataStates: {
        DATA_STATE_CHECKED,
    },
    interactionStates: {
        INTERACTION_STATE_HOVER,
        INTERACTION_STATE_FOCUS_VISIBLE,
    },
});
export default function getRadioButton(transformer, config) {
    const borderStyle = getBorderStyle(transformer, config);
    const borderWidth = getBorderWidth(transformer, config);
    const height = getHeight(transformer);
    const outlineOffset = getOutlineOffset(transformer, config);
    const outlineWidth = getOutlineWidth(transformer, config);
    const outlineColor = getOutlineColor(transformer, config);
    const outlineStyle = getOutlineStyle(transformer, config);
    const borderRadius = getBorderRadius(transformer, config);
    const width = getWidth(transformer);
    const accentColor = getAccentColor(transformer, config);
    const backgroundColor = getBackgroundColor(transformer, config);
    return Object.freeze({
        constants,
        elements: {
            [ELEMENT_RADIO]: {
                styles: {
                    width: width.form.radioButton.default.value,
                    height: height.form.radioButton.default.value,
                    accentColor: accentColor.form.radioButton.default.value,
                    borderWidth: borderWidth.form.input.default.value,
                    borderStyle: borderStyle.form.radioButton.value,
                    borderRadius: borderRadius.form.radioButton.value,
                    backgroundColor: backgroundColor.form.input.default.value,
                },
                variants: {
                    [VARIANT_SMALL]: {
                        styles: {
                            width: width.form.radioButton.s.value,
                            height: height.form.radioButton.s.value,
                        },
                    },
                },
                dataStates: {
                    [DATA_STATE_CHECKED]: {
                        styles: {
                            accentColor: accentColor.form.radioButton.dataStates[DATA_STATE_CHECKED]
                                .value,
                        },
                    },
                },
                interactionStates: {
                    [INTERACTION_STATE_HOVER]: {
                        styles: {
                            accentColor: accentColor.form.radioButton.interactionStates[INTERACTION_STATE_HOVER].value,
                        },
                    },
                    [INTERACTION_STATE_FOCUS_VISIBLE]: {
                        styles: {
                            outlineOffset: outlineOffset.default.value,
                            outlineStyle: outlineStyle.default.value,
                            outlineWidth: outlineWidth.default.value,
                            outlineColor: outlineColor.default.interactionStates[INTERACTION_STATE_FOCUS_VISIBLE].value,
                        },
                    },
                },
            },
            [ELEMENT_LABEL]: {
                components: {
                    [Label.NAME]: {
                        variant: Label.variants.VARIANT_FORM_SECONDARY,
                    },
                },
            },
        },
    });
}
